// import sangwon from '../assets/team/sangwon.JPG'
import noah from '../assets/team/noah.JPG';
// import michael from '../assets/team/michael.JPG';
import juyeop from '../assets/team/juyeop.JPG';
import junsoo from '../assets/team/junsoo.JPG';
// import jae from '../assets/team/jae.JPG';
import jacob from '../assets/team/jacob.JPG';
import adam from '../assets/team/adam.jpeg';
import esther from '../assets/team/esther.JPG';
import kate from '../assets/team/kate.JPG';
// import donggun from '../assets/team/donggun.JPG';
import parker from '../assets/team/parker.jpeg';
// import ryan from '../assets/team/ryan.jpeg';
import charlotte from '../assets/team/charlotte.jpeg';
// import kyungtae from '../assets/team/kyungtae.jpeg';
import suna from '../assets/team/suna.JPG';
// import hoyeol from '../assets/team/hoyeol.jpeg';
import erica from '../assets/team/erica.JPG';
import phillip from '../assets/team/phillip.PNG';
import kaiden from '../assets/team/kaiden.JPG';
import andrew from '../assets/team/keonhoo.JPG';
import lauren from '../assets/team/lauren.jpeg';

    const Members = [
        {
            image: adam,
            name:  'Adam Kim',
            role:  'President',
            description: '',
        },
        {
            image: jacob,
            name: 'Jacob Cho',
            role: 'Vice President',
            description: '',
        },
        {
            image: noah,
            name: 'Noah Kim',
            role: 'Senior Advisor',
            description: '',
        },
        {
            image: esther,
            name: 'Esther Chung',
            role: 'Senior Advisor',
            description: '',
        },
        {
            image: juyeop,
            name: 'Juyeop Lee',
            role: 'Professional Events Lead',
            description: '',
        },
        {
            image: kaiden,
            name: 'Kaiden Ko',
            role: 'Social Events Lead',
            description: '',
        },
        {
            image: suna,
            name: 'Sun A Choe',
            role: 'Project Development Lead',
            description: '',
        },
        {
            image: kate,
            name: 'Kate Shin',
            role: 'Design Lead',
            description: '',
        },
        {
            image: erica,
            name: 'Erica Shin',
            role: 'PR/Marketing Lead',
            description: '',
        },
        {
            image: parker,
            name: 'Parker Chang',
            role: 'Professional Events',
            description: '',
        },
        {
            image: andrew,
            name: 'Keonhoo Park',
            role: 'Professional Events',
            description: '',
        },
        // {
        //     image: kyungtae,
        //     name: 'Kyungtae Kim',
        //     role: 'Events',
        //     description: '',
        // },
        // {
        //     image: ryan,
        //     name: 'Ryan Jang',
        //     role: 'Finance',
        //     description: '',
        // },
        {
            image: phillip,
            name: 'Phillip Suh',
            role: 'PR/Marketing',
            description: '',
        },
        {
            image: lauren,
            name: 'Lauren Kim',
            role: 'Social Events',
            description: '',
        },
        {
            image: charlotte,
            name: 'Charlotte Kwon',
            role: 'Social Events',
            description: '',
        },
    ];

export default Members;

/*

{
    image: ',
    name: '',
    role: '',
    description: '',
},

*/